import { getConfig } from '../Config/ApplicationConfig';
import { getExecutor } from '../Shared/HttpRequestExecutor';
export var searchMedicationLists = function (config, limit, query, data) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).postCancellable("api/v1/medication-lists/search?limit=" + limit + "&query=" + query, config, data);
};
export var createToMedicationList = function (data) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).post("api/v1/medication-lists", data);
};
export var applyBulkActionToMedicationList = function (medicationListId, data) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put("api/v1/medication-lists/" + medicationListId + "/entries/bulk-action", data);
};
export function deleteMedicationList(medicationListId) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).delete("api/v1/medication-lists/" + medicationListId);
}
export var validateMedicationListName = function (name) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put("api/v1/medication-lists/validate-name?name=" + name);
};
export var validateExistingMedicationListName = function (name, medListId) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put("api/v1/medication-lists/" + medListId + "/validate-name?name=" + name);
};
export var validateMedicationDefaultList = function () {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put("api/v1/medication-lists/validate-default");
};
export var getMedicationList = function (config, medListId) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).getCancellable("api/v1/medication-lists/" + medListId, config);
};
export var updateMedicationList = function (medListId, data) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put("api/v1/medication-lists/" + medListId, data);
};
export var publishMedicationList = function (medListId) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put("api/v1/medication-lists/" + medListId + "/publish");
};
export var unpublishMedicationList = function (medListId) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put("api/v1/medication-lists/" + medListId + "/unpublish");
};
export var searchMedicationListEntries = function (config, medListId, query, limit, filter) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).postCancellable("api/v1/medication-lists/" + medListId + "/entries/search?query=" + query + "&limit=" + limit, config, filter);
};
export var updateMedicationListEntry = function (medListId, entryId, data) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put("api/v1/medication-lists/" + medListId + "/entries/" + entryId, data);
};
export var deleteMedicationListEntry = function (medListId, entryId) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).delete("api/v1/medication-lists/" + medListId + "/entries/" + entryId);
};
